export default __webpack_public_path__ + "static/media/Christmas_07.a95cd425.png";